import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {FormGroup} from "@angular/forms";
import {FS3Notification} from "../../../objects/notification";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-play-config-form',
  templateUrl: './play-config-form.component.html',
  styleUrls: ['./play-config-form.component.css']
})
export class PlayConfigFormComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() success = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  public componentForm: FormGroup = new FormGroup({});
  weekday_morning: boolean = false;
  weekday_day: boolean = false;
  weekday_evening: boolean = false;
  weekend_morning: boolean = false;
  weekend_day: boolean = false;
  weekend_evening: boolean = false;
  state: string = 'edit';
  errMsg: string = '';
  constructor() { }

  ngOnInit(): void {
    let payload = this.application.user.payload ? JSON.parse(this.application.user.payload) : new Object();
    this.weekday_morning = payload.play_conf?.weekdays?.split('|')?.includes('morning') ? true : false;
    this.weekday_day = payload.play_conf?.weekdays?.split('|')?.includes('day_middle') ? true : false;
    this.weekday_evening = payload.play_conf?.weekdays?.split('|')?.includes('evening') ? true : false;
    this.weekend_morning = payload.play_conf?.weekends?.split('|')?.includes('morning') ? true : false;
    this.weekend_day = payload.play_conf?.weekends?.split('|')?.includes('day_middle') ? true : false;
    this.weekend_evening = payload.play_conf?.weekends?.split('|')?.includes('evening') ? true : false;
  }

  public handleSubmit(event: Event | void = null): boolean {
    if (event) {
      event.stopPropagation();
    }

    let weekdaysArr = [];
    if(this.weekday_morning) weekdaysArr.push('morning')
    if(this.weekday_day) weekdaysArr.push('day_middle')
    if(this.weekday_evening) weekdaysArr.push('evening')
    let weekendsArr = [];
    if(this.weekend_morning) weekendsArr.push('morning')
    if(this.weekend_day) weekendsArr.push('day_middle')
    if(this.weekend_evening) weekendsArr.push('evening')

    let params = new Object();
    params['gid'] = environment['gid'];
    params['g_hash'] = environment['g_hash'];
    params['privacy_class_uuid'] = this.payload['classItem']['uuid'];
    params['publish_group_event'] = this.payload['publish_group_event'];
    params['payload'] = {};
    params['payload']['play_conf'] = {};
    params['payload']['play_conf']['weekdays'] = weekdaysArr.join('|');
    params['payload']['play_conf']['weekends'] = weekendsArr.join('|');
    this.state = 'loading';
    this.application.apiService.updateProfilePayload(params).subscribe(
      res => {
        this.state = 'edit';
        //this.application.getCurrentUser();
        this.success.emit()
      },
      error => {
        this.state = 'error';
        const { exception } = error;
        const errMsg = error['errMsg'] ? error['errMsg'] : (
          (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
        );
      }
    );
    return true;
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }
}
